import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import {bindActionCreators} from 'redux';
import { hashLocationPlugin, UIView, memoryLocationPlugin } from '@uirouter/react';
import { ConnectedUIRouter } from '@uirouter/redux/lib/react';
import {getStates} from '@/states';
import { setListingConfig,setCheckoutOverlay } from '@/actions/ui';
import { fetchReservationIfNeeded } from '@/actions/reservation';
import AnalyticsContainer from './AnalyticsContainer';
import { hasSelectedChildEvent } from '../views/series/selectors/eventSeries';
import {
    isCurrentRouterState,
    shouldHideEmbeddedCart,
    shouldPinEmbeddedCart,
    showContinueCheckoutBanner
} from '../selectors/ui';
import { getMainEvent } from '../selectors/event';
import ContinueCheckoutBannerContainer from '../../listing/containers/ContinueCheckoutBannerContainer';
import {EMBED_TYPE_MULTI} from "../reducers/ui";
import EmbedStateWrapper from "./EmbedStateWrapper";

class CheckoutContainer extends Component {

    state = {
        firedFirstTransitionHook: false,
    }

    componentDidMount() {
        this.props.setListingConfig(this.props.listingConfig);

        // handle the case where an embed configured to pin the cart loads with
        // the overlay closed and an active reservation
        if (this.props.isEmbed && (this.props.shouldPinEmbeddedCart || this.props.shouldHideEmbeddedCart)) {
            this.props.fetchReservationIfNeeded().catch(() => {});
        }

        // Handle attempt to verify email
        const currentPath = this.props.router.locationService.path();
        if ((currentPath === '/auth/email') && (!this.props.overlay)) {
          this.props.setCheckoutOverlay(true);
        }
    }

    componentDidUpdate(prevProps) {
        //logic that depends on the first router state on app mount can go here
        if (!this.state.firedFirstTransitionHook && prevProps.lastState === null && this.props.lastState) {
            /**
             * if user refreshed, and we end up in a wacky state where we are viewing the ticket picker for a series
             * event with no child event selected, just close the checkout overlay, and force the user to start over
             */
            if (this.props.overlay &&
                this.props.isRecurring &&
                !this.props.hasSelectedChildEvent
            ) {
                if (this.props.isTicketPicker) {
                    this.props.setCheckoutOverlay(false);
                } else if (this.props.isSeriesDatePickerAndNoDateSelected) {
                    this.props.setCheckoutOverlay(false);
                    this.props.router.stateService.transitionTo("ticketPicker");
                }
            }
            this.setState({firedFirstTransitionHook: true});
        }
    }

    render() {
        let child = <div></div>;
        if (this.props.overlay) {
            child = <UIView />;
        } else if (this.props.shouldPinEmbeddedCart && this.props.showContinueCheckoutBanner) {
            child = <ContinueCheckoutBannerContainer />
        }

        //lock page
        if(document.getElementById('page')) {
            if(this.props.overlay) {
                document.body.classList.add('checkout-overlay--open');
                document.getElementById('page').setAttribute("aria-hidden", "true");
                
                if (this.props.isMultiEmbed) {
                  window.parent.scrollTo(0, 0);
                  window.parent.document.body.classList.add('multi-overlay--open');
                }
            } else {
                document.body.classList.remove('checkout-overlay--open');
                document.getElementById('page').setAttribute("aria-hidden", "false");

                if (this.props.isMultiEmbed) {
                  window.parent.document.body.classList.remove('multi-overlay--open');
                }
            }
        }

        let plugin = hashLocationPlugin;

        if(this.props.urlRouting === false || this.props.isEmbed) {
            plugin = memoryLocationPlugin;
        }
        return(
            <div id="checkout-overlay">
                <div id="checkout__modal"></div>

                <AnalyticsContainer analytics={this.props.analytics}/>
                {this.props.isMultiEmbed && <EmbedStateWrapper/>}
                <ConnectedUIRouter
                    router={this.props.router}
                    plugins={[plugin]}
                    states={getStates(this.props.store)}
                >
                    {child}
                </ConnectedUIRouter>
            </div>
        )
    }
}

const mapStateToProps = state => {
    let theEvent = getMainEvent(state) ?? null;
    return {
        isEmbed: !!state.ui.isEmbed,
        isMultiEmbed: !!state.ui.isEmbed && state.ui.embedType === EMBED_TYPE_MULTI,
        isSeriesDatePickerAndNoDateSelected:
            isCurrentRouterState("seriesDatePicker")(state) &&
                (!state.eventSeries.selectedDate || state.eventSeries.selectedDate === ""),
        overlay: state.ui.overlay,
        urlRouting: state.ui.urlRouting,
        confirmation: state.ui.confirmation,
        analytics: state.ui.uiConfig.analytics,
        isRecurring: theEvent ? theEvent.event.isRecurring : false,
        hasSelectedChildEvent: hasSelectedChildEvent(state),
        isTicketPicker: isCurrentRouterState("ticketPicker")(state),
        shouldPinEmbeddedCart: shouldPinEmbeddedCart(state),
        shouldHideEmbeddedCart: shouldHideEmbeddedCart(state),
        showContinueCheckoutBanner: showContinueCheckoutBanner(state),
        lastState:
            state.router &&
            typeof state.router.last === "object" &&
            Object.keys(state.router.last).length
                ? state.router.last
                : null
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        setListingConfig,
        setCheckoutOverlay,
        fetchReservationIfNeeded,
    }, dispatch);
}

CheckoutContainer.propTypes = {
    overlay: PropTypes.bool,
    confirmation: PropTypes.bool,
    listingConfig: PropTypes.object.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutContainer)
